import { Injectable } from '@angular/core';
import { SubSystem } from '../models/subsystem.enum';
import { SystemStatusService } from './systemstatus.service';
import { HttpClient } from '@angular/common/http';
import { Subscriber, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EventBusService, EventType, ATMEventData } from './eventbus.service';
import { HttpResponse, HttpStatus, HttpRequestOptions } from '../models/http';

@Injectable()
export class HttpService {
  constructor(protected eventBus: EventBusService) {}

  public request(options: HttpRequestOptions, forceFetch?: boolean): Observable<HttpResponse> {
    //This needs to be implemented when we move to the non-WL version
    //this.httpClient.get(...); this returns an Observable
    throw new Error('Not Implemented');
  }

  protected handleNotifications(options: HttpRequestOptions, response: HttpResponse): void {
    if (options.isUserAction === undefined || options.isUserAction === false) return;

    let message: string | null = null;

    switch (response.status) {
      case HttpStatus.Error:
        if (options.errorMessageOverride !== undefined) message = options.errorMessageOverride(response);
        else message = response.errorMessage;
        break;
      case HttpStatus.Offline:
        if (options.offlineMessageOverride !== undefined) message = options.offlineMessageOverride(response);
        else message = response.errorMessage;
        break;
      case HttpStatus.Success:
        if (options.successMessageOverride !== undefined) message = options.successMessageOverride(response);
        else message = 'Operation was successful';
        break;
      default:
        break;
    }

    if (response.status === HttpStatus.Success && message !== null)
      this.eventBus.fireEvent(EventType.NOTIFY_SUCCESS_EVENT, new ATMEventData(null, () => message));
    else if (message !== null) this.eventBus.fireEvent(EventType.NOTIFY_FAILURE_EVENT, new ATMEventData(null, () => message));
    else if (response.status === HttpStatus.Error) {
      return this.eventBus.fireEvent(
        EventType.NOTIFY_FAILURE_EVENT,
        new ATMEventData(null, () => 'There seems to be issue. Please contact system administator')
      );
    }
  }
}
